// Which admin area a page is in: /admin (the new login) or /shop-app (inside Shopify admin, App Bridge token).
export const inAdminArea = () => {
  const p = window.location.pathname;
  return p === "/admin" || p.startsWith("/admin/");
};

export const adminBase = () => (inAdminArea() ? "/admin" : "/shop-app");

export const adminHomeLabel = () => (inAdminArea() ? "← Admin" : "← Duckify app");
